module.exports = __webpack_public_path__ + "static/media/angela_josifovska.a86502d4.jpeg";